// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-navbar-link-wrapper #linkA div {
  padding-left: 18px !important;
}
.side-navbar-link-wrapper #linkA div span {
  margin-left: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/style.scss"],"names":[],"mappings":"AAEQ;EACI,6BAAA;AADZ;AAEY;EACI,gBAAA;AAAhB","sourcesContent":[".side-navbar-link-wrapper{\n    #linkA{\n        div{\n            padding-left: 18px!important;\n            span{\n                margin-left: 3px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
